import api from './api';

export const dashboardAPI = {
  getStats: async () => {
    try {
      const [users, products, orders, blogs, categories, banners] = await Promise.all([
        api.get('/user/getall?limit=1'),
        api.get('/product/get-all?limit=1'),
        api.get('/order/get-all-order?limit=1'),
        api.get('/blogs/get-all?limit=1'),
        api.get('/category/getall'),
        api.get('/banner/getall?limit=1')
      ]);

      console.log('API Responses:', {
        users: users.data,
        products: products.data,
        orders: orders.data,
        blogs: blogs.data,
        categories: categories.data,
        banners: banners.data
      });

      console.log('Blog response details:', {
        blogTotal: blogs.data.total,
        blogCount: blogs.data.count,
        blogData: blogs.data.data?.length
      });

      return {
        totalUsers: users.data.totalUsers || 0,
        totalProducts: products.data.totalProducts || 0,
        totalOrders: orders.data.totalOrders || 0,
        totalBlogs: blogs.data.totalBlogs || blogs.data.total || blogs.data.count || blogs.data.data?.length || 0,
        totalCategories: categories.data.categories ? categories.data.categories.length : 0,
        totalBanners: banners.data.totalbanner || 0,
      };
    } catch (error) {
      console.error('Dashboard API Error:', error);
      return {
        totalUsers: 0,
        totalProducts: 0,
        totalOrders: 0,
        totalBlogs: 0,
        totalCategories: 0,
        totalBanners: 0,
      };
    }
  },
  getRecentActivity: async () => {
    try {
      const [recentUsers, recentProducts, recentOrders, recentBlogs] = await Promise.all([
        api.get('/user/getall?limit=3&page=1'),
        api.get('/product/get-all?limit=3&page=1'),
        api.get('/order/get-all-order?limit=3&page=1'),
        api.get('/blogs/get-all?limit=3&page=1')
      ]);

      const activities: Array<{text: string; color: string; time: string}> = [];

      // Recent users
      if (recentUsers.data.data) {
        recentUsers.data.data.forEach((user: any) => {
          activities.push({
            text: `New user registered: ${user.fullName || user.firstName || 'User'}`,
            color: 'bg-green-500',
            time: new Date(user.createdAt).toLocaleString()
          });
        });
      }

      // Recent products
      if (recentProducts.data.data) {
        recentProducts.data.data.forEach((product: any) => {
          activities.push({
            text: `Product added: ${product.productname || product.name || 'Product'}`,
            color: 'bg-blue-500',
            time: new Date(product.createdAt).toLocaleString()
          });
        });
      }

      // Recent orders
      if (recentOrders.data.data) {
        recentOrders.data.data.forEach((order: any) => {
          activities.push({
            text: `New order received: #${order._id.slice(-6)}`,
            color: 'bg-yellow-500',
            time: new Date(order.createdAt).toLocaleString()
          });
        });
      }

      // Recent blogs
      if (recentBlogs.data.data) {
        recentBlogs.data.data.forEach((blog: any) => {
          activities.push({
            text: `Blog published: ${blog.title || 'Blog'}`,
            color: 'bg-purple-500',
            time: new Date(blog.createdAt).toLocaleString()
          });
        });
      }

      // Sort by creation time (newest first)
      activities.sort((a, b) => new Date(b.time).getTime() - new Date(a.time).getTime());

      return activities.slice(0, 4); // Return top 4 activities
    } catch (error) {
      console.error('Recent Activity API Error:', error);
      return [];
    }
  },
};